module.exports = __webpack_public_path__ + "img/zhiyingMain.68e83811.png";